import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  Flex,
  Heading,
  Menu,
  MenuList,
  MenuItem,
  HStack,
  MenuButton,
  Button,
  VStack,
  Box,
  Select,
  Text,
  Checkbox,
  CheckboxGroup,
  CardBody,
} from "@chakra-ui/react";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  selectedProvincesState,
  selectedPemdaState,
  sidebarisexpandAtom,
  months,
  startMonthAtom,
  endMonthAtom,
  selectedJenisTkdState,
} from "states/recoil";
import { HiChevronDown, HiOutlineXCircle } from "react-icons/hi";

export function ToggleFullScreen({ rawData, children, onClose }) {
  //filter state
  const [provinceList, setProvinceList] = useState([
    "PROVINSI PAPUA",
    "PROVINSI PAPUA TENGAH",
    "PROVINSI PAPUA SELATAN",
    "PROVINSI PAPUA PEGUNUNGAN",
    "PROVINSI PAPUA BARAT",
    "PROVINSI PAPUA BARAT DAYA",
  ]);
  const [pemdaList, setPemdaList] = useState([]);
  const [jenisTKDList, setJenisTKDList] = useState([]);
  const monthsdata = useRecoilValue(months);
  const [startMonth, setStartMonth] = useRecoilState(startMonthAtom);
  const [endMonth, setEndMonth] = useRecoilState(endMonthAtom);
  //recoil state

  const [selectedProvinces, setSelectedProvinces] = useRecoilState(
    selectedProvincesState
  );
  const [selectedPemda, setSelectedPemda] = useRecoilState(selectedPemdaState);
  const [selectedJenisTKD, setSelectedJenisTKD] = useRecoilState(
    selectedJenisTkdState
  );

  // Update pemda options based on selected province
  useEffect(() => {
    if (!rawData.length || !selectedProvinces.length) return;

    const filtered = rawData.filter((row) =>
      selectedProvinces.includes(row["NM PROV"])
    );
    const newPemda = Array.from(
      new Set(filtered.map((row) => row["NM PEMDA"]))
    );

    setPemdaList(newPemda);
    setSelectedPemda(newPemda);
  }, [selectedProvinces]);

  // Update Jenis TKD options based on selected pemda
  useEffect(() => {
    if (!rawData.length || !selectedPemda.length) return;

    const filtered = rawData.filter((row) =>
      selectedPemda.includes(row["NM PEMDA"])
    );

    const newJenisTKD = Array.from(
      new Set(filtered.map((row) => row["JENIS TKD"]).filter(Boolean))
    );

    setJenisTKDList(newJenisTKD);
    setSelectedJenisTKD(newJenisTKD);
  }, [selectedPemda]);

  //rule all selcted filter
  const isAllSelected = selectedPemda.length === pemdaList.length;
  const isNoneSelected = selectedPemda.length === 0;
  const displayTextPemda =
    isAllSelected || isNoneSelected ? "Semua Pemda" : selectedPemda[0];
  const isAllSelectedProv = selectedProvinces.length === provinceList.length;
  const isNoneSelectedProv = selectedProvinces.length === 0;
  const displayTextProv =
    isAllSelectedProv || isNoneSelectedProv
      ? "Semua Provinsi"
      : selectedProvinces[0];

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <Card
        style={{
          background: "white",
          borderRadius: 8,
          padding: 20,
          margin: "20px",
          width: "80vw",
          height: "90vh",
          overflow: "auto",
          boxShadow: "0 0 15px rgba(0,0,0,0.3)",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <CardHeader alignItems="center">
          <Flex justify="space-between" width="100%" alignItems="center">
            {/* <Heading size="md">Dashboard Penyaluran TKD</Heading> */}
            <Flex gap={4}>
              {/* Filter Provinsi */}
              <Menu closeOnSelect={true}>
                <MenuButton as={Button} rightIcon={<HiChevronDown />}>
                  {displayTextProv}
                </MenuButton>

                <MenuList
                  maxHeight="300px"
                  overflowY="auto"
                  minWidth="200px"
                  zIndex={3}
                >
                  {/* "Semua Provinsi" option */}
                  <MenuItem
                    onClick={() => setSelectedProvinces([...provinceList])}
                  >
                    Semua Provinsi
                  </MenuItem>

                  {/* Individual province options */}
                  {provinceList.map((prov) => (
                    <MenuItem
                      key={prov}
                      onClick={() => setSelectedProvinces([prov])}
                    >
                      {prov}
                    </MenuItem>
                  ))}
                </MenuList>
              </Menu>

              {/* Filter Pemda */}
              <Menu closeOnSelect={false}>
                <MenuButton as={Button} rightIcon={<HiChevronDown />}>
                  {displayTextPemda}
                </MenuButton>

                <MenuList
                  maxHeight="300px"
                  overflowY="auto"
                  minWidth="250px"
                  zIndex={3}
                >
                  {/* "Semua Pemda" item */}
                  <MenuItem onClick={() => setSelectedPemda([...pemdaList])}>
                    Semua Pemda
                  </MenuItem>

                  {pemdaList.map((pemda) => (
                    <MenuItem
                      key={pemda}
                      onClick={() => setSelectedPemda([pemda])}
                    >
                      {pemda}
                    </MenuItem>
                  ))}
                </MenuList>
              </Menu>

              {/* Filter Jenis TKD */}
              <Menu closeOnSelect={false}>
                <MenuButton
                  as={Button}
                  rightIcon={<HiChevronDown />}
                  variant={"outline"}
                  backgroundColor={
                    selectedJenisTKD.length === jenisTKDList.length
                      ? "white"
                      : "#CBD5E0"
                  }
                >
                  Filter Jenis TKD
                </MenuButton>
                <MenuList
                  maxHeight="300px"
                  overflowY="auto"
                  minWidth="200px"
                  zIndex={3}
                >
                  <CheckboxGroup
                    value={selectedJenisTKD}
                    onChange={setSelectedJenisTKD}
                  >
                    <VStack align="start" p={2}>
                      <Checkbox
                        isChecked={
                          selectedJenisTKD.length === jenisTKDList.length
                        }
                        isIndeterminate={
                          selectedJenisTKD.length > 0 &&
                          selectedJenisTKD.length < jenisTKDList.length
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedJenisTKD(jenisTKDList);
                          } else {
                            setSelectedJenisTKD([]);
                          }
                        }}
                      >
                        Select All
                      </Checkbox>
                      {jenisTKDList.map((jenis) => (
                        <Checkbox key={jenis} value={jenis}>
                          {jenis}
                        </Checkbox>
                      ))}
                    </VStack>
                  </CheckboxGroup>
                </MenuList>
              </Menu>

              {/* Filter Bulan */}
              <HStack spacing={4} align="center" mb={4}>
                <Box>
                  {/* <Text>Start Month</Text> */}
                  <Select
                    fontWeight={600}
                    value={startMonth}
                    onChange={(e) => {
                      const selected = e.target.value;
                      setStartMonth(selected);

                      if (
                        monthsdata.indexOf(selected) >
                        monthsdata.indexOf(endMonth)
                      ) {
                        setEndMonth(selected);
                      }
                    }}
                  >
                    {monthsdata.map((month) => (
                      <option key={month} value={month}>
                        {month}
                      </option>
                    ))}
                  </Select>
                </Box>
                <Text fontWeight={600}>s.d.</Text>
                <Box>
                  {/* <Text>End Month</Text> */}
                  <Select
                    fontWeight={600}
                    value={endMonth}
                    onChange={(e) => {
                      const selected = e.target.value;

                      if (
                        monthsdata.indexOf(selected) >=
                        monthsdata.indexOf(startMonth)
                      ) {
                        setEndMonth(selected);
                      }
                    }}
                  >
                    {monthsdata.map((month) => {
                      const isDisabled =
                        monthsdata.indexOf(month) <
                        monthsdata.indexOf(startMonth);
                      return (
                        <option key={month} value={month} disabled={isDisabled}>
                          {month}
                        </option>
                      );
                    })}
                  </Select>
                </Box>
              </HStack>
            </Flex>
          </Flex>
        </CardHeader>
        <CardBody w={"100%"}>{children}</CardBody>
        <Box position={"absolute"} right={15} top={5}>
          <HiOutlineXCircle
            onClick={onClose}
            aria-label="Close popup"
            fontSize={"28px"}
            cursor={"pointer"}
          />
        </Box>
      </Card>
    </div>
  );
}
